import script from "./ConsultorBloqueiosRepository.vue?vue&type=script&lang=js"
export * from "./ConsultorBloqueiosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__